import localAxios from '../../localAxios';
import { workspaceQuizLockURL } from '../workspacesURLs';

interface PutWorkspaceQuizLockResponse {
  httpStatus: number;
  message: string;
  data: {
    lockValidForRequestingUser: boolean;
    quizPublishedDate: string;
  };
}

export async function putWorkspaceQuizLock({
  workspaceId,
  workspaceQuizId,
  quizId,
}: {
  workspaceId: string;
  workspaceQuizId: string;
  quizId: number;
}) {
  const url = workspaceQuizLockURL({
    workspaceId,
    workspaceQuizId,
  });
  const result = await localAxios.put<PutWorkspaceQuizLockResponse>(url.href, {
    quiz_id: quizId,
  });
  const {
    data: { data },
  } = result;
  return data;
}
